import React from 'react';
import { useSelector } from 'react-redux';

import { ProductCarousel } from 'src/explore/compositions/ProductCarousel';
import { Recombee } from 'src/explore/services/recommendations/Recombee';
import { useShopConfig } from 'src/explore/hooks/useShopConfig';
import { IStore } from 'src/explore/types/store';

interface Props {
  clickRef?: string;
  hideLove?: boolean;
  hideMerchant?: boolean;
  pageType?: string;
}

export const RecommendedProducts: React.FC<Props> = ({
  clickRef,
  hideLove,
  hideMerchant,
  pageType,
}) => {
  const [ loaded, setLoaded ] = React.useState<boolean>( false );
  const [ products, setProducts ] = React.useState<any[]>();
  const [ recommId, setRecommId ] = React.useState<string>();
  const { isWhitelabel } = useShopConfig();
  const accountPristine = useSelector(( state: IStore ) => state.data.account.pristine );
  const accountId = useSelector(
    ( state: IStore ) => state.data.account.data && state.data.account.data.hashed_id
  );
  const visitorId = useSelector(
    ( state: IStore ) => state.data.account.meta && state.data.account.meta.visitor_id
  );
  const identity = accountId || visitorId;

  const recombee = React.useMemo(() => new Recombee(), []);

  React.useEffect(() => {
    const searchParams = new URLSearchParams( window.location.search );

    setRecommId( searchParams.get( 'recomm_id' ));
  }, []);

  React.useEffect(() => {
    if ( loaded || accountPristine || !identity ) return;

    let request = null;

    switch ( pageType ) {
      case 'home': {
        request = recombee.getItemsForUser( identity, 15, { scenario: 'homepage' });

        break;
      }
      case 'also_bought': {
        const filter = isWhitelabel
          ? `'is_sold_out' == false and 'whitelabel_visible' == true and 'merchant_id' == ${
              ( window as any ).__data.whitelabelMerchantId
            }`
          : "'is_sold_out' == false and 'visible' == true";
        const scenario = isWhitelabel ? 'also_bought_whitelabel' : 'also_bought';

        request = recombee.getItemsForItem( identity, ( window as any ).__data.productId, 15, {
          filter,
          scenario,
          userImpact: 0.2,
          rotationRate: 0.2,
          rotationTime: 7200,
          booster: '(if \'price_in_cents\' > context_item["price_in_cents"] then 1.1 else 1)',
        });

        break;
      }
      default:
    }

    setLoaded( true );

    request.then( async ( res: any ) => {
      const recommendedProducts = await Recombee.extractJson( res );
      setProducts( recommendedProducts );
      setRecommId( res.recommId );
    });
  }, [ accountPristine, identity, isWhitelabel, loaded, pageType, recombee ]);

  if ( !products ) return null;

  return (
    <ProductCarousel
      hideLove={hideLove}
      hideMerchant={hideMerchant}
      linkParameters={{
        ref: clickRef,
        recomm_id: recommId,
      }}
      pristine={!loaded}
      products={products}
      recommId={recommId}
      template="carousel"
      title="Recommended For You"
    />
  );
};
